export default class GameColors {
	public static WHITE = "#ffffff";
	public static BLACK = "#000000";
	public static OFF_WHITE = "#fdf1e3";
	public static BROWN = "#b88c5c";
	public static STORY_TEXT = "#c98a21";
	public static YELLOW = "#ffbb00";
	public static LIGHT_YELLOW = "#F8DE84";
	public static TAN = "#746356";
	public static ORANGE = "#ffa800";
	public static GREEN = "#7fc701";
	public static LOCKED = "#696ca0";
	public static BLUE = "#52e5f2";
	public static DARKPINK = "#aa226c";
	public static PURPLE = "#696ca0";
	public static PALE_PURPLE = "#8385d2";
	public static RED = "#df4361";
}
